Object.defineProperty(exports,"__esModule",{value:true});var DEFAULT_CHAT_SETTINGS=exports.DEFAULT_CHAT_SETTINGS={
texts:{
onlineMessage:'Hi, there! How can we help you?',
onlineTitle:'Chat with us!'},

design:{
selectedImageOption:'2',
selectedRadiusOption:'8'},

layout:{
collapsedAsRounded:false,
position:'1'}};


//////////////////
// WEBPACK FOOTER
// ../~/inbox-common/dist/default-chat-settings.js
// module id = 286
// module chunks = 0